// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI, { Message } from 'element-ui'
import './permission'
import 'element-ui/lib/theme-chalk/index.css'
import '@/icons'
import filters from './filters'
import animate from 'animate.css'
import '@/assets/styles/index.scss' // global css
import '@/assets/styles/theme.scss' // global css
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.use(animate)
Vue.config.productionTip = false
for (const key in filters) {
  Vue.filter(key, filters[key])
}
Vue.prototype.$message = Message
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js